const PREFIX = '/csearch/api'

// URL
const URLS = {
  OSS_LOGIN: PREFIX + '/users/sso-login', // 登录
  LOGOUT: PREFIX + '/users/logout', // 登出
  GET_CONSTANTS: PREFIX + '/resource/get-business-type-and-subject'
}

// cookie保存用户名/groups信息/过期时间
const USER_NAME = 'username'
const USER_GROUPS = 'perm_groups'
const LONG_DAYS = 70 * 365

// 全局常量
const SENSITIVE_WORDS = 'sensitive_type_data'
const SUBJECTS = 'object_data'
const BUSSINESS = 'business_type_data'
const BUSSINESS_SUBJECTS = 'business_subject_data'

export {
  URLS,
  USER_NAME,
  USER_GROUPS,
  LONG_DAYS,
  SENSITIVE_WORDS,
  SUBJECTS,
  BUSSINESS,
  BUSSINESS_SUBJECTS
}
